const colors = [
  "cyan",
  "geekblue",
  "red",
  "blue",
  "green",
  "yellow",
  "orange",
  "purple",
  "pink",
  "brown",
  "lime",
  "navy",
  "maroon",
  "olive",
  "teal",
  "aqua",
  "fuchsia",
];

export default colors;
